module.exports = __webpack_public_path__ + "static/media/main.802d7f47.png";